<template>
  <a-card :class="'exchange-color-' + status">
    <a-tag v-if="status === 0" class="remove-right">접수</a-tag>
    <a-tag v-if="status === 1" class="remove-right" color="blue">처리 중</a-tag>
    <a-tag v-if="status === 2" class="remove-right" color="green">성공</a-tag>
    <a-tag v-if="status === 3" class="remove-right" color="red">실패</a-tag>
    <a-tag v-if="status === 4" class="remove-right" color="yellow">맡김</a-tag>
    <p style="font-size: 0.75em; margin-top: 10px;"></p>
    <dl>
      <dt>시간:</dt>
      <dd>{{ uploadAt.format('LLL') }}</dd>
      <dt>사유:</dt>
      <dd>{{ reason || '메세지를 입력하지 않았습니다.' }}</dd>
      <dt>도매 정보:</dt>
      <dd>
        <a-card>
          <b>도매 이름:</b>
          {{ wholesale.name}}
          <br />
          <b>전화번호:</b>
          <a
            class="ant-btn"
            :href="`tel://${wholesale.phone}`"
            style="color: #000;"
          >{{ wholesale.phone }}</a>
          <br />
          <b>휴대폰 번호:</b>
          <a
            class="ant-btn"
            :href="`tel://${wholesale.mobile}`"
            style="color: #000;"
          >{{ wholesale.mobile }}</a>
          <br />
          <b>위치:</b>
          {{ wholesale.location.building +
          ' (' + wholesale.location.mall + ') ' +
          wholesale.location.floor + '층 ' +
          wholesale.location.row + '열 ' +
          wholesale.location.place + '호' }}
        </a-card>
      </dd>
      <dt>메세지:</dt>
      <dd>
        <a-card>
          <b>사입삼촌:</b>
          {{ contents || '메세지가 없습니다.' }}
          <br />
          <b>도매:</b>
          {{ answer || '메세지가 없습니다.' }}
        </a-card>
      </dd>

      <dt>품목:</dt>
      <a-card>
        <SaibItemDetail :items="details" />
      </a-card>
    </dl>

    <div class="fl-right" v-if="status === 0">
      <a-button @click="onDelete" type="danger" icon="delete">삭제</a-button>
    </div>
  </a-card>
</template>
<script>
import SaibItemDetail from "../../components/Saib/SaibItemDetail";
import config from "../../config";
import AxiosMiddleware from "../../libs/AxiosMiddleware";
import Axios from "axios";
import OPCODE from "../../libs/OPCODE";
import { mapActions } from "vuex";

export default {
  name: "ExchangeItem",

  props: [
    "idx",
    "status",
    "reason",
    "contents",
    "details",
    "uploadAt",
    "wholesale",
    "answer"
  ],
  methods: {
    ...mapActions(["refreshExchanges"]),
    async onDelete() {
      const { idx, refreshExchanges } = this;

      this.$confirm({
        title: "교환/반납 취소",
        content: "정말로 삭제하시겠습니까? 추후 복구할 수 없습니다.",
        okText: "네, 삭제합니다.",
        okType: "primary",
        cancelText: "아니요",
        async onOk() {
          try {
            const { data } = await Axios.delete(
              `${config.hostname}/v1/exchange/${idx}`,
              {
                withCredentials: true
              }
            );

            if (AxiosMiddleware(data.opcode)) {
              switch (data.opcode) {
                case OPCODE.SUCCESS:
                  refreshExchanges();
                  config.alert.mixin({
                    type: "success",
                    title: "성공적으로 삭제되었습니다."
                  });
                  break;
                default:
                  config.alert.mixin({
                    type: "error",
                    title: "알 수 없는 이유로 인하여 삭제할 수 없습니다."
                  });
              }
            }
          } catch (err) {
            config.alert.mixin({
              type: "error",
              title: "삭제할 수 없습니다.\n인터넷 상태를 확인해주세요."
            });
          }
        }
      });
    }
  },
  components: { SaibItemDetail }
};
</script>
<style scoped>
.remove-right {
  margin-right: 0px;
}
</style>
